import { useUI } from "../lib/store";
import type { ThemeId } from "../themes/themes";

export function useTheme(): {
  theme: ThemeId;
  setTheme: (theme: ThemeId) => void;
} {
  const theme = useUI((s) => s.theme);
  const setTheme = useUI((s) => s.setTheme);
  return { theme, setTheme };
}
